module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"formats":"JPG, PNG, HEIF","file_size":"Файл не больше 10 MB"}}')
  delete Component.options._Ctor
}
